export default __webpack_public_path__ + "static/media/diamond-clarity_over-md.88cd9e08.png";